import { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'
import { 
  ProductCarouselNew, 
  ProductsCarouselSales, 
  ProductsCategoryCarousel, 
  ProductsGroupCarousel,
  ProductsPopularCarousel,
  ProductsPreviouslyOrderedCarousel
} from '@features/products-carousel'


const productBlockComponents: Record<string, React.FC<BlockProps>> = {
  group: ({ payload}) => <ProductsGroupCarousel id={payload?.id as string} />,
  category: ({payload}) => <ProductsCategoryCarousel categoryId={payload?.id as string} />,
  popular: () => <ProductsPopularCarousel />,
  sale: () => <ProductsCarouselSales />,
  previouslyOrdered: () => <ProductsPreviouslyOrderedCarousel />,
  new: () => <ProductCarouselNew />,
}

export default function ProductsBlock ({
  block,
  payload,
  shopId
}: BlockProps) {

  const BlockComponent = block.subtype ? productBlockComponents[block.subtype] : null

  if (!BlockComponent) {
    return null
  }

  return (
    <div className={styles.root__carousel}>
      <BlockComponent
        block={block}
        payload={payload}
        shopId={shopId}
      />
    </div>
  )
}